import { render, staticRenderFns } from "./Coupon.vue?vue&type=template&id=55e5bd6a&scoped=true&"
import script from "./Coupon.vue?vue&type=script&lang=js&"
export * from "./Coupon.vue?vue&type=script&lang=js&"
import style0 from "./Coupon.vue?vue&type=style&index=0&id=55e5bd6a&lang=scss&scoped=true&"
import style1 from "./Coupon.vue?vue&type=style&index=1&id=55e5bd6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e5bd6a",
  null
  
)

export default component.exports